import {GitHubAvatar} from '@github-ui/github-avatar'
import {userHovercardPath} from '@github-ui/paths'
import {Link} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {ParticipantFragment$key} from './__generated__/ParticipantFragment.graphql'
import styles from './Participant.module.css'

type ParticipantProps = {
  participant: ParticipantFragment$key
}

export function Participant({participant}: ParticipantProps) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment ParticipantFragment on User {
        __typename
        id
        login
        name
        profileResourcePath
        avatarUrl(size: 64)
      }
    `,
    participant,
  )
  const {login, avatarUrl} = data

  return (
    <Link href={`/${login}`} data-hovercard-url={userHovercardPath({owner: login})}>
      <GitHubAvatar src={avatarUrl} size={20} alt={`@${login}`} className={styles.GitHubAvatar} />
    </Link>
  )
}

try{ Participant.displayName ||= 'Participant' } catch {}